const { persistCache } = require('apollo-cache-persist');
const getClient = require('./client');

module.exports = () =>
  getClient(cache => persistCache({ cache, storage: window.localStorage }));
